import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceManagerService } from 'src/app/service-manager.service';

@Component({
  selector: 'app-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent implements OnInit {

  constructor(public router: Router, public serviceManager: ServiceManagerService) {  
   }

  ngOnInit(): void {
  }
}
